import { render, staticRenderFns } from "./ModalFooterTerms.vue?vue&type=template&id=cf4072d2&scoped=true&"
import script from "./ModalFooterTerms.vue?vue&type=script&lang=js&"
export * from "./ModalFooterTerms.vue?vue&type=script&lang=js&"
import style0 from "./ModalFooterTerms.vue?vue&type=style&index=0&id=cf4072d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4072d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog})
